import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useLoaderData } from "react-router-dom";

import { selectSetting } from "../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import { IPlayer, ITeam, ITeamSchedule } from "../../../../types/api";

const PitchCounts = (): React.JSX.Element => {
    const { currentTeam, teamId, schedule, players } = useLoaderData() as {
        currentTeam: ITeam;
        teamId: ITeam["id"];
        schedule: ITeamSchedule;
        players: IPlayer[];
    };

    const currentYear = parseInt(
        useAppSelector(state =>
            selectSetting(state, "majorybl_current_league_year"),
        )?.setting,
    );

    const currentTeamsLeague = currentTeam.leagues?.find(
        l => l.year === currentYear,
    );

    const hasPitchCounts = schedule.games.some(game => {
        return (
            (game.home.id === teamId && game.home.pitchCounts != null) ||
            (game.visitor.id === teamId && game.visitor.pitchCounts != null)
        );
    });

    return (
        <div data-testid="pitchCountsContent" className="pitchCountsContent">
            <Container>
                <Row>
                    <Col>
                        <h3>{`${currentTeamsLeague?.name}: ${currentTeam.name} Pitch Count History`}</h3>
                    </Col>
                </Row>
                {hasPitchCounts ? (
                    schedule.games.map(s => {
                        const teamLocation =
                            s.home.id === parseInt(teamId.toString())
                                ? "home"
                                : "visitor";

                        return (
                            s[teamLocation].pitchCounts && (
                                <section className="game" key={s.id}>
                                    <Row>
                                        <Col>
                                            <h4>{`${new Date(
                                                s.date,
                                            ).toLocaleDateString("en-US", {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit",
                                            })} - ${s.visitor.name} vs ${
                                                s.home.name
                                            }`}</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={10}>
                                            <Table striped bordered>
                                                <thead>
                                                    <tr>
                                                        <th>Player Name</th>
                                                        <th>Pitch Count</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {s[
                                                        teamLocation
                                                    ].pitchCounts?.map(
                                                        (i, idx) => {
                                                            const pitcher =
                                                                players.find(
                                                                    p =>
                                                                        parseInt(
                                                                            p.id.toString(),
                                                                        ) ===
                                                                        i.player,
                                                                );

                                                            return (
                                                                <tr key={idx}>
                                                                    <td
                                                                        width={
                                                                            "75%"
                                                                        }
                                                                    >
                                                                        {`${pitcher?.firstName} ${pitcher?.lastName}`}
                                                                    </td>
                                                                    <td
                                                                        width={
                                                                            "25%"
                                                                        }
                                                                    >
                                                                        {
                                                                            i.count
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            );
                                                        },
                                                    )}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                </section>
                            )
                        );
                    })
                ) : (
                    <h4>No recorded pitch counts</h4>
                )}
            </Container>
        </div>
    );
};

export default PitchCounts;
